module.exports = __webpack_public_path__ + "img/sd.157df901.svg";